import { openDepositUrl } from './openDepositUrl';
import { useOperatorLinks } from './useOperatorLinks';

export const INSUFFICIENT_BALANCE_CODE = 'INSUFFICIENT_BALANCE';

/**
 * "Add funds" handler for a purchase failure: defined only when the failure
 * is an insufficient balance AND the casino gave us a `deposit_url`.
 * Undefined → render the failure exactly as before (no button).
 *
 * Tapping it dismisses the failure first: we can't tell when (or whether)
 * the deposit lands, so the player comes back to the pack page with the
 * refreshed balance and buys again, instead of to a stale "Insufficient
 * balance" they have to close by hand.
 */
export function useAddFundsAction(
  code: string | undefined,
  dismissFailure: () => void,
): (() => void) | undefined {
  const { depositUrl } = useOperatorLinks();
  if (code !== INSUFFICIENT_BALANCE_CODE || !depositUrl) return undefined;
  return () => {
    dismissFailure();
    openDepositUrl(depositUrl);
  };
}
